

import React, { memo } from 'react';
import MultiValueAddon from '../../components/MultiValueAddon';
import { MULTI } from '../../../../constants/dropdownTypes';








function SupersizeMyEdit({
  supersizeMyEdit,
  onChangeAddon,
  disabled,
  SUPERSIZE_MY_EDIT
}) {
  return (
    <MultiValueAddon
      options={SUPERSIZE_MY_EDIT}
      addonValue={supersizeMyEdit}
      title="Supersize My Edit"
      subtitle="Includes most other production requests. Select add-ons used."
      onChangeAddon={onChangeAddon('SUPERSIZE_MY_EDIT')}
      disabled={disabled}
      icon="extrafootage"
      dropdownType={MULTI}
      placeholder="Select Add-ons Used"
      editingMode
      addItemLabel="Additional Add-on" />);


}

export default memo(SupersizeMyEdit);